export default __webpack_public_path__ + "static/media/price-title-line-white.5a0f4b72.svg";